module.exports = __webpack_public_path__ + "static/media/stripe.4f799911.svg";